// src/components/AnimatedRoutes.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import WelcomeScreen from "./Welcome";
import PaymentScreen from "./PaymentScreen";
import PhotoCapture from "./PhotoCapture";
import PreviewConfirmation from "./PreviewConformation";
import SharingOptions from "./SharingOptions";
import ThankYouScreen from "./Thankyou";
import ClearDataScreen from "./ClearDataScreen";
import PrintPage from "./PrintPage";
import AssignBoothName from "./AssignBoothName";
import PolaroidFilterComponent from "./Filter";
// import Overlay from "./Overlay";

const pageTransition = {
  initial: { opacity: 0, y: 50, scale: 0.95 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 1, ease: "circIn" },
  },
  exit: {
    opacity: 0,
    y: -50,
    scale: 0.95,
    transition: { duration: 1, ease: "circIn" },
  },
};

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      {/* <Overlay /> */}
      <motion.div key={location.pathname} {...pageTransition}>
        <Routes location={location}>
          <Route path="/" element={<WelcomeScreen />} />
          <Route path="/payment" element={<PaymentScreen />} />
          <Route path="/photo-capture" element={<PhotoCapture />} />
          <Route
            path="/preview-confirmation"
            element={<PreviewConfirmation />}
          />
          <Route path="/sharing-options" element={<SharingOptions />} />
          <Route path="/thank-you" element={<ThankYouScreen />} />
          <Route path="/print-page" element={<PrintPage />} />
          <Route path="/clear-data" element={<ClearDataScreen />} />
          <Route path="/assign-name" element={<AssignBoothName />} />
          <Route path="/test" element={<PolaroidFilterComponent />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
